"use client";

import React, { useState } from "react";
import { BannerImage } from "@/app/components/MoveBrasil/BannerImage";
import { MOVE_BRASIL_FORM_ID } from "@/app/config/moveBrasil";
import {
	MOVE_BRASIL_MODEL_COLORS,
	MOVE_BRASIL_MODEL_SPECS,
} from "@/app/config/moveBrasilModel";
import styles from "@/styles/move-brasil.module.scss";

function scrollToForm(e: React.MouseEvent<HTMLAnchorElement>) {
	e.preventDefault();
	document
		.getElementById(MOVE_BRASIL_FORM_ID)
		?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export const ModelSection: React.FC = () => {
	const [selectedIndex, setSelectedIndex] = useState(0);
	const selectedColor = MOVE_BRASIL_MODEL_COLORS[selectedIndex];

	return (
		<section className={styles.model}>
			<div className={styles.container}>
				<div className={styles.modelGrid}>
					<div className={styles.modelVisual}>
						<h2 className={styles.modelTitle}>Conheça o Jeep Renegade</h2>

						<figure className={styles.modelImageWrap}>
							<BannerImage
								src={selectedColor.image}
								alt={`Jeep Renegade ${selectedColor.name}`}
								className={styles.modelImage}
								fallbackClassName={styles.modelImageFallback}
							/>
						</figure>

						<div
							className={styles.colorCarousel}
							role="listbox"
							aria-label="Cores disponíveis"
						>
							{MOVE_BRASIL_MODEL_COLORS.map((color, index) => (
								<button
									key={color.id}
									type="button"
									className={`${styles.colorSwatch} ${
										index === selectedIndex
											? styles.colorSwatchActive
											: ""
									}`}
									role="option"
									aria-selected={index === selectedIndex}
									aria-label={color.name}
									onClick={() => setSelectedIndex(index)}
								>
									<img
										src={color.swatch}
										alt=""
										className={styles.colorSwatchImg}
										draggable={false}
									/>
								</button>
							))}
						</div>

						<div className={styles.colorName}>
							<span className={styles.colorNameLine} aria-hidden="true" />
							<span className={styles.colorNameText}>
								{selectedColor.name}
							</span>
							<span className={styles.colorNameLine} aria-hidden="true" />
						</div>
					</div>

					<div className={styles.modelSpecs}>
						{MOVE_BRASIL_MODEL_SPECS.map((spec) => (
							<article key={spec.label} className={styles.specItem}>
								<div className={styles.specAccent} aria-hidden="true" />
								<h3 className={styles.specLabel}>{spec.label}</h3>
								<p className={styles.specValue}>{spec.value}</p>
							</article>
						))}
					</div>
				</div>

				<div className={styles.modelCtaWrap}>
					<a
						className={styles.modelCta}
						href={`#${MOVE_BRASIL_FORM_ID}`}
						onClick={scrollToForm}
					>
						QUERO O MEU JEEP RENEGADE
					</a>
				</div>
			</div>
		</section>
	);
};
